module.exports = __webpack_public_path__ + "img/logo-sac.3363678b.png";